/* tslint:disable */
/* eslint-disable */
/**
 * POK
 * Opis api POK
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface CreateEmailResendDto
 */
export interface CreateEmailResendDto {
    /**
     * 
     * @type {string}
     * @memberof CreateEmailResendDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmailResendDto
     */
    emailTo?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmailResendDto
     */
    emailCc?: string;
    /**
     * 
     * @type {string}
     * @memberof CreateEmailResendDto
     */
    emailBcc?: string;
}

/**
 * Check if a given object implements the CreateEmailResendDto interface.
 */
export function instanceOfCreateEmailResendDto(value: object): boolean {
    let isInstance = true;
    isInstance = isInstance && "id" in value;

    return isInstance;
}

export function CreateEmailResendDtoFromJSON(json: any): CreateEmailResendDto {
    return CreateEmailResendDtoFromJSONTyped(json, false);
}

export function CreateEmailResendDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): CreateEmailResendDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'emailTo': !exists(json, 'emailTo') ? undefined : json['emailTo'],
        'emailCc': !exists(json, 'emailCc') ? undefined : json['emailCc'],
        'emailBcc': !exists(json, 'emailBcc') ? undefined : json['emailBcc'],
    };
}

export function CreateEmailResendDtoToJSON(value?: CreateEmailResendDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'emailTo': value.emailTo,
        'emailCc': value.emailCc,
        'emailBcc': value.emailBcc,
    };
}

